import { getApi } from '../util/lib';

export const isDebug = process.env.REACT_APP_DEBUG_UI === 'true';

export const trackEvent = async (eventData = {}) => {
  try {
    if (!eventData.eventType || !eventData.sessionId) {
      if (isDebug)
        console.log('[SVA][trackEvent] Missing required fields', eventData);
      return {
        success: false,
        error: 'Missing required fields: eventType, sessionId',
      };
    }
    if (isDebug)
      console.log('[SVA][trackEvent.data]', {
        eventData,
      });
    const client = await getApi({
      baseURL: process.env.REACT_APP_API_URL,
    });
    const response = await client.post('/analytics/trackers/track', eventData);
    const json = response.data;
    if (!json.success)
      throw new Error(`Failed to track event: ${eventData.eventType}`);
    if (isDebug)
      console.log('[SVA][trackEvent.result]', {
        eventData,
        response: json,
      });
    return json;
  } catch (error) {
    if (isDebug) console.error('[SVA][trackEvent.error]', error);
    return { success: false, error };
  }
};
